import { render, staticRenderFns } from "./storicoPagamenti.vue?vue&type=template&id=ee4bee1e"
import script from "./storicoPagamenti.vue?vue&type=script&lang=js"
export * from "./storicoPagamenti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports